import type { ReportDerivedClaim } from '../../types/reportClaim';
import { createRegistryResolver, tierSource } from './resolveCore';
import type { RegistryResolver, ResolverFactoryOptions } from './types';

export interface ClaimResolverInput extends ResolverFactoryOptions {
  claims?: ReportDerivedClaim[];
  llmClaims?: Array<{ sedFieldPath: string; value: unknown; reportId: string }>;
}

export function createClaimResolver(opts: ClaimResolverInput): RegistryResolver {
  const fieldSources: Record<string, ReturnType<typeof tierSource>[]> = {};
  const currentClaims = (opts.claims ?? []).filter((c) => !c.supersededBy);

  for (const claim of currentClaims) {
    const sources = fieldSources[claim.sedFieldPath] ?? [];
    sources.push(
      tierSource(2, claim.value, {
        kind: 'report',
        ref: `claim:${claim.id}`,
        label: `${claim.reportType} claim`,
      }),
    );
    fieldSources[claim.sedFieldPath] = sources;
  }

  for (const llm of opts.llmClaims ?? []) {
    const sources = fieldSources[llm.sedFieldPath] ?? [];
    sources.push(
      tierSource(3, llm.value, {
        kind: 'llm-inference',
        ref: `llm:claim:${llm.reportId}:${llm.sedFieldPath}`,
        label: 'LLM claim inference',
      }),
    );
    fieldSources[llm.sedFieldPath] = sources;
  }

  return createRegistryResolver({
    registryId: 'claim',
    siteId: opts.siteId,
    fieldSources,
    now: opts.now,
  });
}
